module.exports = __webpack_public_path__ + "static/media/theme-classic.d3b855fe.png";